module.exports = {
	"Ice.Default.Router": "GanymedeGlacier2/router:ws -h localhost -p 5063",
	"App.ClientManager": "Ganymede/ClientManager",
	"App.UserManager": "Ganymede/UserManager",
	"App.PermissionManager": "Ganymede/PermissionManager",
	"App.Permissions": "Ganymede/Permissions"
};


//////////////////
// WEBPACK FOOTER
// ./ice.config.yaml
// module id = 775
// module chunks = 0